import compassUrl from '../assets/compass.svg';

type CompassProps = {
  yaw: number; // From View360 viewChange
  northOffset?: number; // Optional offset to align 0 yaw with true North
};

export const PanoramaCompass = ({ yaw, northOffset = 0 }: CompassProps) => {
  const adjustedYaw = (yaw + northOffset) % 360;

  return (
    <div
      className="compass pointer-events-none absolute left-4 top-4 z-10 h-[68px] w-[68px] sm:h-[82px] sm:w-[82px]"
      style={{
        transform: `rotate(${adjustedYaw}deg)`,
        transformOrigin: 'center',
      }}
    >
      <img src={compassUrl} alt="Compass" className="h-full w-full" />
    </div>
  );
};
